import { icn_ex_detailing, icn_in_detailing, icn_full_detailing } from "../../imports";
import './Services.css';

const services = [
    {
        title: 'Exterior Detailing',
        description: "It is all about bringing out the best in your vehicle's outside surfaces, giving it a fresh, new look that's sure to turn heads!",
        image: icn_ex_detailing
    },
    {
        title: 'Interior Detailing',
        description: "Ensuring every inside surface, from seats to carpets, is not just clean, but also protected, keeping your vehicle in top condition!",
        image: icn_in_detailing
    },
    {
        title: 'Full Detailing',
        description: "The ultimate package, covering both the interior and exterior of your vehicle, ensuring it looks and feels brand new!",
        image: icn_full_detailing
    }
]

const Services = () => {
    return (
        <div className="services-container">
            <div className="services-header-container">
                <p className="services-pre-header">Convenient for every client</p>
                <h1 className="services-header">Top values for you</h1>
                <p className="services-sub-header">Try variety of benefits when using our services</p>
            </div>
            <div className="services-content">
                {services.map((service, index) => (
                    <div className='services-detail' key={index}>
                        <div className="services-texts-container">
                            <p className="services-title">{service.title}</p>
                            <p className="services-description">{service.description}</p>
                        </div>
                        <div className="services-icn">
                            <img src={service.image} alt="right arrow" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Services;